<wa-dialog label="Assignments Overview" style="--width: 80vw;" (waHide)="cancel()" open="true" withFooter="true">
  <div class="wa-stack">
    <div class="wa-stack">
      <h4>Supervisions</h4>
      @if (!hasSupervisingData()) {
        <span>&mdash; no supervisions &mdash;</span>
      } @else {
        <table class="wa-hover-rows wa-zebra-rows">
          <tbody>
            @for (exam of fixedSupervising; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-fixed"><wa-icon name="thumbtack" variant="classic"></wa-icon>fixed</td>
              </tr>
            }
            @for (exam of suggestedSupervising; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-suggested"><wa-icon name="thumbtack-angle" variant="regular"></wa-icon>suggested</td>
              </tr>
            }
            @for (exam of excludedSupervising; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-excluded"><wa-icon name="ban" variant="classic"></wa-icon>excluded</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div class="wa-stack">
      <h4>Correction</h4>
      @if (!hasCorrectingData()) {
        <span>&mdash; no corrections &mdash;</span>
      } @else {
        <table class="wa-hover-rows wa-zebra-rows">
          <tbody>
            @for (exam of fixedCorrecting; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-fixed"><wa-icon name="thumbtack" variant="classic"></wa-icon>fixed</td>
              </tr>
            }
            @for (exam of suggestedCorrecting; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-suggested"><wa-icon name="thumbtack-angle" variant="regular"></wa-icon>suggested</td>
              </tr>
            }
            @for (exam of excludedCorrecting; track exam.id) {
              <tr>
                <td>{{ exam.module.code }}</td>
                <td>{{ exam.module.name }}</td>
                <td>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }}
                  -{{ exam.main_exam.end | date: timeFormat }}
                </td>
                @if (exam.has_repetition) {
                <td>{{ exam.retake_exam!.begin | date: dateFormat }}, {{ exam.retake_exam!.begin | date: timeFormat }}
                  -{{ exam.retake_exam!.end | date: timeFormat }}
                </td>
                } @else {
                  <td> </td>
                }
                <td class="assignment-excluded"><wa-icon name="ban" variant="classic"></wa-icon>excluded</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
  <div slot="footer">
    <div class="wa-cluster">
      <!--wa-button variant="neutral" appearance="filled" (click)="cancel()">Cancel</wa-button-->
      <wa-button
        variant="neutral"
        appearance="filled"
        (click)="apply()">
        Close
      </wa-button>
    </div>
  </div>
</wa-dialog>

